import { Component } from "react"
import PropTypes from "prop-types"
import InlineErrors from "shared/components/inline_errors"
import StringPerLineInput from "shared/components/string_per_line_input"
import displayFlash from "partners/scripts/display_flash"

import { updateEmbeddedRedirectURIs } from "../../shared/lib/graphql"

// This is obviously a super weak validation, but I don't think we really need
// to do anything except check that there's a protocol and something host-y.
const urlRegex = /^[a-z-]+:\/\/\S+$/i

export default class EmbeddedRedirectUris extends Component {
  state = {
    value: this.props.initialValue || [],
    errors: [],
    submitting: false,
  }

  handleChange = value => {
    this.setState({ value, errors: [] })
  }

  validate = () => {
    const errors = this.state.value
      .filter(uri => uri) // omit empty last line
      .map(url => !url.match(urlRegex) && `The URL “${url}” is invalid`)
      .filter(err => err)

    this.setState({ errors })
    return errors.length > 0
  }

  handleSubmit = event => {
    event.preventDefault()

    const hasErrors = this.validate()
    if (hasErrors) return

    const { serviceModuleName } = this.props
    const value = this.state.value.filter(uri => uri) // omit empty last line

    this.setState({ submitting: true })

    updateEmbeddedRedirectURIs(serviceModuleName, value)
      .then(newValue => {
        displayFlash("Redirect URIs updated")
        this.setState({
          value: newValue,
          submitting: false,
        })
      })
      .catch(() => {
        this.setState({
          errors: ["Sorry, there was an unexpected error. Please try again"],
          submitting: false,
        })
      })
  }

  render() {
    const { serviceModuleName } = this.props
    const { value, errors, submitting } = this.state

    return (
      <form className="form" onSubmit={this.handleSubmit}>
        <section className="form-section">
          <p>
            IFTTT can redirect users back to your app after they enable an
            embedded Applet, but you need to provide a list of approved URIs to
            send the user back to. User-specific paths or parameters can be
            appended to an approved URI when redirecting, as long as the base
            matches.
          </p>

          <div className="field">
            <div className="label">
              <label>Approved redirect URIs</label>
            </div>
            <InlineErrors errors={errors} />
            <div className="input">
              <StringPerLineInput onChange={this.handleChange} value={value} />
              <p className="note">
                You can provide multiple redirect URIs, one on each line.
              </p>
            </div>
          </div>
        </section>

        <div className="actions">
          <input
            className="button-secondary"
            data-track-data={JSON.stringify({ service: serviceModuleName })}
            data-track-event="panda.service.redirect_uris.save.clicked"
            type="submit"
            value={submitting ? "Saving…" : "Save"}
            disabled={submitting}
          />
        </div>
      </form>
    )
  }
}

EmbeddedRedirectUris.propTypes = {
  serviceModuleName: PropTypes.string,
  initialValue: PropTypes.array,
}
